import type {AppFilter} from "../../filters";
import type {AppTableChangeEvent} from "../../../ui";
import {getFilterConditions} from "../../filters";

export const getFilter = (filters: AppFilter[]): AppTableChangeEvent["filter"] => {
  return getFilterConditions(filters);
};